import { all, takeEvery, put, fork, call, takeLatest } from "redux-saga/effects";
import { timesheetService } from "@iso/services";
import actions from "./actions";

function* getListTimesheet() {
  yield takeEvery(actions.GET_LIST_TIMESHEET, function* ({ payload }) {
    try {
      const result = yield call(timesheetService.fetchTimesheets, payload);
      yield put({
        type: actions.GET_LIST_TIMESHEET_SUCCESS,
        timesheets: result ? result.rows : [],
        total: result ? result.total : 0,
        accountTotal: result ? result.accountTotal || 0 : 0,
        teamSummaryCount: result ? result.teamSummaryCount || 0 : 0,
      });
    } catch (e) {
      yield put({ type: actions.GET_LIST_TIMESHEET_ERROR, error: e });
    }
  });
}

function* saveTimesheet() {
  yield takeLatest(actions.SAVE_TIMESHEET, function* ({ payload }) {
    const { entries, resolve, reject } = payload;
    try {
      const response = yield call(timesheetService.saveTimesheet, entries);
      yield put({ type: actions.SAVE_TIMESHEET_SUCCESS });
      if (resolve) {
        yield resolve(response);
      }
    } catch (e) {
      yield put({ type: actions.SAVE_TIMESHEET_ERROR, error: e });
      if (reject) {
        reject(e);
      }
    }
  });
}

export default function* rootSaga() {
  yield all([fork(getListTimesheet), fork(saveTimesheet)]);
}
